import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-privacy--is-private-link", -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M1 5h14v11H1z"
      }),
      _createElementVNode("path", {
        d: "M2.5 6.5v8h11v-8h-11zm7.975-3.975A3.489 3.489 0 0 0 8 1.5c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 0 0 4.5 5h7c0-.966-.392-1.841-1.025-2.475zM3 5a5 5 0 1 1 10 0h2v11H1V5h2zm3.857 6.035C6.34 10.733 6 10.233 6 9.667 6 8.747 6.895 8 8 8s2 .746 2 1.667c0 .566-.339 1.066-.857 1.368v1.489c0 .263-.256.476-.572.476H7.43c-.316 0-.572-.213-.572-.476v-1.49z",
        fill: "#F23218",
        "fill-rule": "nonzero"
      })
    ], -1)
  ]))]))
}
export default { render: render }